import { render, staticRenderFns } from "./SwiperImagesFreeX.vue?vue&type=template&id=a37e67c4&scoped=true&"
import script from "./SwiperImagesFreeX.vue?vue&type=script&lang=js&"
export * from "./SwiperImagesFreeX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37e67c4",
  null
  
)

export default component.exports